import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

//api
import { getMarketLocations } from "../../api/marketLocations";

//components
import { initMarketMap } from "../map/index";

import SwiperCarousel from "../swiper/index";

//utils
import { cleanStringFromHTMLTags } from "../../utils/string";
import { renderMustacheTemplate } from "../../utils/other";

class DynamicMarketLocations {
  constructor(dropdownEl) {
    this.dropdownEl = dropdownEl;
    this.tl = null;
    gsap.registerPlugin(ScrollTrigger);
  }

  init = () => {
    this.initCarousels();
    initMarketMap();
    this.handleDropdownSelect();
    this.hideLoader();
    if ($(window).width() > 1024) {
      this.animationScroll();
    }
  };

  handleDropdownSelect = () => {
    const that = this;
    $(this.dropdownEl)
      .find("li")
      .click(function () {
        $(this)
          .parents(".dropdown")
          .find(".dropdown-toggle")
          .html(
            $(this).text() +
              ' <span class="icon-angle-down d-inline-block btn-icon font-weight-bold"></span>'
          );
        $(this)
          .parents(".dropdown")
          .find(".dropdown-toggle")
          .val($(this).data("label"));

        that.getMarketData($(this).data("value"));
      });
  };

  initCarousels() {
    SwiperCarousel.init();
  }

  animationScroll = () => {
    const animatedEl = document.querySelector(".js-animation-scroll");
    const $nav = $(".sticky-nav-with-banner");
    const startPoint =
      $("#wpadminbar").length > 0 ? $nav.height() + 32 : $nav.height();
    const dynamicWrapper = $(".js-dynamic-wrapper");
    const dynamicBoxShadow = $(".js-target-box-shadow");
    const dynamicSectionHeight = dynamicWrapper.height();
    const isMoreThanTwoEl = animatedEl.offsetHeight > dynamicSectionHeight;

    if (isMoreThanTwoEl) {
      dynamicWrapper.addClass("pb-lg");

      gsap.utils.toArray(".dynamic-container").forEach((panel) => {
        dynamicBoxShadow.show();
        this.tl = gsap.timeline({
          scrollTrigger: {
            trigger: panel,
            start: `-${startPoint}`,
            end: "=100%",
            scrub: true,
            pin: isMoreThanTwoEl,
            toggleClass: "active",
            onEnter: () => {
              dynamicBoxShadow.show();
            },
            onLeave: () => {
              dynamicBoxShadow.hide();
            },
            onEnterBack: () => {
              dynamicBoxShadow.show();
            },
          },
          defaults: {
            ease: "none",
          },
        });

        this.tl.add("start", 0);
        this.tl.fromTo(
          animatedEl,
          {
            y: "0px",
          },
          {
            y: `-${animatedEl.offsetHeight - dynamicSectionHeight}px`,
          },
          "start"
        );
      });
    } else {
      dynamicBoxShadow.hide();
      dynamicWrapper.removeClass("pb-lg");
    }
  };

  hideLoader = () => {
    $(".loader").addClass("d-none");
  };
  showLoader = () => {
    $(".loader").removeClass("d-none");
  };

  getMarketData = (id) => {
    this.showLoader();

    getMarketLocations(id)
      .done((responseData) => {
        //Locations render
        const locations = responseData.locations.map((location, i) => ({
          ...location,
          index: i + 1,
          location_title: location.location_title.replaceAll("&#8211;", "&"),
        }));
        const templateLocationsData = {
          ...responseData,
          locations: locations,
        };

        renderMustacheTemplate(
          "#js-template-locations",
          templateLocationsData,
          "#js-target-locations",
          this.initCarousels
        );
        window.marketLocations = responseData.locations;

        // Market Description render
        const templateMarketData = {
          market: {
            market_description: cleanStringFromHTMLTags(
              responseData.market.market_description
            ),
            market_short_desc: cleanStringFromHTMLTags(
              responseData.market.market_short_desc
            ),
          },
        };
        renderMustacheTemplate(
          "#js-template-market-description",
          templateMarketData,
          "#js-target-market-description"
        );

        // Modals render
        renderMustacheTemplate(
          "#js-template-location-modal",
          templateLocationsData,
          "#js-target-locations-modal"
        );

        //Map
        initMarketMap();

        //Animation
        if ($(window).width() > 1024) {
          this.tl && this.tl.scrollTrigger && this.tl.scrollTrigger.kill();
          this.animationScroll();
        }
      })
      .always(() => {
        this.hideLoader();
      });
  };
}

export default DynamicMarketLocations;
